import React from 'react';

import { Container, Row, Col } from 'aplazame-design-system';

import TabComponent from '../TabComponent';


export default function TabSection({
    tabs,
    activeTab
}) {
    return (
        <section>
            <Container
                pb={{ xs: 8, lg: 9 }}
            >
                <Row>
                    <Col
                        col={{ xl: 10, xxl: 8 }}
                        offset={{ xl: 1, xxl: 2 }}
                    >
                        <TabComponent
                            items={tabs.map(tab => ({
                                active: activeTab && activeTab.id === tab.id ? true : false,
                                title: tab.label,
                                href: tab.link.slug ? `/${tab.link.slug}/` : (tab.externalLink ? tab.externalLink : '#')
                            }))}
                        />
                    </Col>
                </Row>
            </Container>
        </section>
    );
}